const royerStoreFinderSwiperWrapperClass = "royer-store-finder-page-wrapper"

let royerStoreFinderSwiper;
initSwiperAfterLibLoad("." + royerStoreFinderSwiperWrapperClass, {
      // Optional parameters
      direction: "horizontal",
      shortSwipes: true,
      simulateTouch: false,
      slideToClickedSlide: false,
      slidesPerView: 'auto',
      slidesPerGroupAuto: false,
      spaceBetween: 24,
      loop: false,
      speed: 500,
      autoHeight: false,
      effect: "slide",
      allowSlideNext: false,
      allowTouchMove: false,
      on: {
      },
  }).then(result => royerStoreFinderSwiper = result);